import { render, staticRenderFns } from "./Sended.vue?vue&type=template&id=47ddf4ee"
import script from "./Sended.vue?vue&type=script&lang=js"
export * from "./Sended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports